// Shim re-export to preserve existing import path
// The model command has been folderized under ./model/
export { modelCommand } from "./model/index.js";
